export default __webpack_public_path__ + "static/media/illustration-elements_icon-telegram.af44d4df.svg";